export const SPACEBAR_KEY_CODE = 32;

export default {
  SPACEBAR_KEY_CODE,
};
